import * as d3 from 'd3'
export default {
  methods: {

    draw_Forms() {
      this.canvasForm = this.svg
      .append('g')
      .attr('id', `CANVAS_FROM`)
      .attr('transform', `translate(0, 0)`)
      .attr('font-family', 'roboto')
      .attr('cursor', 'default')


      // this.canvasForm
      // .append('image')
      // .attr('xlink:href', this.HOST + '/Monthly_Report/Erection/Erection_WC212.jpg')
      // .attr('x', 0).attr('y', 30).attr('width', 400)

      this.draw_Blocks()

     

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },


  }
}